









import Vue from 'vue';
// not going to type flickity
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Flickity from 'vue-flickity';
import { IFlickityOptions } from '../../common/interfaces/external.interface';

const autoPlayTiming = 5000;

interface ISliderComponent {
  internalFlickityOptions: IFlickityOptions;
}

interface ISliderRefs {
  slider: typeof Flickity;
}

export default Vue.extend({
  components: { Flickity },
  data(): ISliderComponent & { $refs?: ISliderRefs } {
    return {
      internalFlickityOptions: {},
    };
  },
  props: {
    amountOfSlides: {
      required: true,
      type: Number,
    },
    flickityOptions: {
      default: (): IFlickityOptions => {
        return {
          adaptiveHeight: false,
          autoPlay: autoPlayTiming,
          cellAlign: `left`,
          prevNextButtons: false,
          wrapAround: true,
        };
      },
      type: Object as () => IFlickityOptions,
    },
    sliderInitialized: {
      required: true,
      type: Boolean,
    },
  },
  mounted(): void {
    this.internalFlickityOptions = { ...this.flickityOptions };
    this.modifyFlickityOptions();
    window.addEventListener(`resize`, window._.debounce(() => this.modifyFlickityOptions(), 250));
  },
  destroyed(): void {
    window.removeEventListener(`resize`, this.modifyFlickityOptions);
  },
  methods: {
    modifyFlickityOptions(): void {
      if(this.amountOfSlides > 4) {
        this.internalFlickityOptions.arrowShape = {
          x0: 0,
          x1: 45,
          x2: 60,
          x3: 15,
          y1: 50,
          y2: 50,
        };
        this.internalFlickityOptions.autoPlay = autoPlayTiming;
        this.internalFlickityOptions.prevNextButtons = true;
      } else if(matchMedia(`screen and (max-width: 1380px)`).matches) {
        this.internalFlickityOptions.autoPlay = autoPlayTiming;
      } else {
        this.internalFlickityOptions.autoPlay = false;
      }
      Vue.nextTick(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$refs.slider.rerender();
      });
    },
  },
  watch: {
    sliderInitialized: {
      handler(): void {
        if(this.sliderInitialized) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.$refs.slider.resize();
        }
      },
    },
  },
});
